import {tokens, colors} from '@commercial-helios/ui/theme'
import styled from 'styled-components'

import {Body} from '@/components/feature-block'
import {checkmarkList} from '@/styles/lists'
import {Section} from '@helios/shared/styles/grid'
import mq from '@helios/shared/utils/media-query'

export const HeroSection = styled(Section)`
    /* Styling for inline icons within rich text */
    ${Body} > *:first-child {
        p,
        img {
            display: inline;
            vertical-align: middle;
        }

        img {
            margin: 0;
        }

        p + *:not(img) {
            display: block;
            margin: 0;
        }
    }
`

export const ThreeColSection = styled(Section)`
    display: grid;
    gap: ${tokens.spacing60};
`

interface ItemProps {
    hideOnMobile?: boolean
}

export const ThreeColSectionItem = styled.div<ItemProps>`
    display: ${(props) => (props.hideOnMobile ? 'none' : 'grid')};
    gap: ${tokens.spacing20};

    ${mq.min('sm')} {
        display: grid;
    }

    ul {
        ${checkmarkList('black')}
    }

    hr {
        border-color: ${colors.border.secondary};
    }
`

export const TestimonialStars = styled.div`
    display: grid;
    gap: ${tokens.spacing16};
`

export const TestimonialAttribution = styled.div`
    strong {
        color: ${colors.text.brand};
    }
`
